"use client";

import { useFormatter, useTimeZone } from "next-intl";
import { cn } from "@/shared/lib";

type DateInput = Date | string | number | null | undefined;

function normalizeDate(value: DateInput): Date | null {
  if (value == null) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value === "number") {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function DateCell({
  date,
  className,
  dateOnly = false,
}: {
  date: DateInput;
  className?: string;
  dateOnly?: boolean;
}) {
  const formatter = useFormatter();
  const timeZone = useTimeZone();
  const d = normalizeDate(date);

  if (!d) {
    return <span className={cn("text-muted-foreground", className)}>-</span>;
  }

  const formatOptions = dateOnly
    ? {
        year: "numeric" as const,
        month: "2-digit" as const,
        day: "2-digit" as const,
        timeZone,
      }
    : {
        year: "numeric" as const,
        month: "2-digit" as const,
        day: "2-digit" as const,
        hour: "2-digit" as const,
        minute: "2-digit" as const,
        second: "2-digit" as const,
        hour12: false,
        timeZone,
      };

  return (
    <span className={className} suppressHydrationWarning>
      {formatter.dateTime(d, formatOptions)}
    </span>
  );
}

export default DateCell;
